export default "__VITE_ASSET__BGtLmzoR__"